import React, { FC } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { BILLING_PAGE_PATH } from 'application/consts';
import { useLocation, useNavigate } from 'application/providers/RouterProvider';
import { useNotificationContext } from 'application/providers/NotificationProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import useAcceptanceAdvancedModalViewModel from './useAcceptanceAdvancedModalViewModel';
import { TEXTS } from './texts';

import styles from './index.module.scss';

const AcceptanceAdvancedModal: FC<ModalProps[ModalTypes.ACCEPTANCE_ADVANCED]> = ({ close }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const notification = useNotificationContext();

  const { startSigningAcceptanceAdvancedLoading, handleRedirectToAcceptanceAdvanced } =
    useAcceptanceAdvancedModalViewModel({
      pathname: location.pathname,
      showStartSigningErrorNotification: () => {
        notification.showErrorNotification({
          children: TEXTS.ACCEPTANCE_ADVANCED_MODAL_NOTIFICATION_ERROR_MESSAGE,
        });
      },
    });

  return (
    <ModalScreen
      title={TEXTS.ACCEPTANCE_ADVANCED_MODAL_TITLE}
      onClose={close}
      contentClassName={styles.acceptanceAdvancedModalContent}
      actionButtons={[
        <Button
          elementId="button_redirect_to_acceptance_advanced_modal"
          key="button_redirect_to_acceptance_advanced_modal"
          type={ButtonType.PRIMARY}
          isLoading={startSigningAcceptanceAdvancedLoading}
          onClick={handleRedirectToAcceptanceAdvanced}>
          {TEXTS.ACCEPTANCE_ADVANCED_MODAL_PRIMARY_BUTTON_TEXT}
        </Button>,
        <Button
          elementId="button_redirect_to_billing_page_modal"
          key="button_redirect_to_billing_page_modal"
          type={ButtonType.SECONDARY}
          isLoading={startSigningAcceptanceAdvancedLoading}
          onClick={() => navigate(BILLING_PAGE_PATH, { replace: true })}>
          {TEXTS.ACCEPTANCE_ADVANCED_MODAL_SECONDARY_BUTTON_TEXT}
        </Button>,
      ]}>
      <div>
        <strong>{TEXTS.ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION_HEADER}</strong>
      </div>
      <div>{TEXTS.ACCEPTANCE_ADVANCED_MODAL_DESCRIPTION}</div>
    </ModalScreen>
  );
};

export default React.memo(AcceptanceAdvancedModal);
